<template>
    <el-dialog :title="title" :visible.sync="visible" width="600px">
        <el-form label-width="110px" ref="form" :model="form" :rules="rules">
            <el-form-item label="标签名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入标签名称"></el-input>
            </el-form-item>
            <el-form-item label="自动打标签条件" prop="label_condition">
                <div style="display: flex; flex-direction: column; row-gap: 10px">
                    <el-row type="flex" align="middle">
                        <el-checkbox :disabled="!!form.uuid" v-model="form.a">浏览产品</el-checkbox>
                        <el-input :disabled="!form.a || !!form.uuid" style="margin-left: 10px" v-model="form.av" placeholder="请输入浏览次数">
                            <template slot="append">次</template>
                        </el-input>
                    </el-row>
                    <el-form-item prop="av" style="margin: -10px 0 10px 90px"></el-form-item>
                    <el-row type="flex" align="middle">
                        <el-checkbox :disabled="!!form.uuid" v-model="form.b">停留时长</el-checkbox>
                        <el-input :disabled="!form.b || !!form.uuid" style="margin-left: 10px" v-model="form.bv" placeholder="请输入停留时长">
                            <template slot="append">秒</template>
                        </el-input>
                    </el-row>
                    <el-form-item prop="bv" style="margin: -10px 0 10px 90px"></el-form-item>
                    <el-row type="flex" align="middle">
                        <el-checkbox :disabled="!!form.uuid" v-model="form.c">评论</el-checkbox>
                        <el-input :disabled="!form.c || !!form.uuid" style="margin-left: 10px" v-model="form.cv" placeholder="请输入评论次数">
                            <template slot="append">次</template>
                        </el-input>
                    </el-row>
                    <el-form-item prop="cv" style="margin: -10px 0 10px 90px"></el-form-item>
                    <el-row type="flex" align="middle">
                        <el-checkbox :disabled="!!form.uuid" v-model="form.d">转发</el-checkbox>
                        <el-input :disabled="!form.d || !!form.uuid" style="margin-left: 10px" v-model="form.dv" placeholder="请输入转发次数">
                            <template slot="append">次</template>
                        </el-input>
                    </el-row>
                    <el-form-item prop="dv" style="margin: -10px 0 10px 90px"></el-form-item>
                    <el-row type="flex" align="middle">
                        <el-checkbox :disabled="!!form.uuid" v-model="form.e">是否收藏</el-checkbox>
                        <el-switch :disabled="!form.e || !!form.uuid" style="margin-left: 10px" v-model="form.ev"> </el-switch>
                    </el-row>
                    <el-form-item prop="ev" style="margin: -10px 0 10px 90px"></el-form-item>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { add, edit, detail } from "@/api/member/tag";

export default {
    data() {
        return {
            form: {},
            rules: {
                name: [{ required: true, message: "请输入标签名称" }],
                av: [{ required: false, message: "请输入浏览次数" }],
                bv: [{ required: false, message: "请输入停留时长" }],
                cv: [{ required: false, message: "请输入评论次数" }],
                dv: [{ required: false, message: "请输入转发次数" }],
                ev: [{ required: false, message: "请选择是否收藏" }],
            },
            visible: false,
            title: "",
        };
    },
    watch: {
        ["form.a"](val) {
            this.rules.av = [{ required: !!val, message: "请输入浏览次数" }];
        },
        ["form.b"](val) {
            this.rules.bv = [{ required: !!val, message: "请输入停留时长" }];
        },
        ["form.c"](val) {
            this.rules.cv = [{ required: !!val, message: "请输入评论次数" }];
        },
        ["form.d"](val) {
            this.rules.dv = [{ required: !!val, message: "请输入转发次数" }];
        },
        ["form.e"](val) {
            this.rules.ev = [{ required: !!val, message: "请选择是否收藏" }];
        },
    },
    methods: {
        open(uuid) {
            if (uuid) {
                this.title = "编辑标签";
                this.getDetail(uuid);
            } else {
                this.title = "新增标签";
                this.form = {};
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
            this.visible = true;
        },
        getDetail(uuid) {
            detail({ uuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form = result || {};
                    result.condition.forEach((item) => {
                        if (item.condition_type == 1) {
                            this.form.a = true;
                            this.form.av = item.condition_value;
                        }
                        if (item.condition_type == 2) {
                            this.form.b = true;
                            this.form.bv = item.condition_value;
                        }
                        if (item.condition_type == 3) {
                            this.form.c = true;
                            this.form.cv = item.condition_value;
                        }
                        if (item.condition_type == 4) {
                            this.form.d = true;
                            this.form.dv = item.condition_value;
                        }
                        if (item.condition_type == 5) {
                            this.form.e = true;
                            this.form.ev = item.condition_value;
                        }
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    name: this.form.name,
                    label_condition: [],
                };
                if (this.form.a) {
                    params.label_condition.push({
                        condition_type: 1,
                        condition_value: this.form.av,
                    });
                }
                if (this.form.b) {
                    params.label_condition.push({
                        condition_type: 2,
                        condition_value: this.form.bv,
                    });
                }
                if (this.form.c) {
                    params.label_condition.push({
                        condition_type: 3,
                        condition_value: this.form.cv,
                    });
                }
                if (this.form.d) {
                    params.label_condition.push({
                        condition_type: 4,
                        condition_value: this.form.dv,
                    });
                }
                if (this.form.e) {
                    params.label_condition.push({
                        condition_type: 5,
                        condition_value: this.form.ev,
                    });
                }
                if (this.form.uuid) {
                    params.uuid = this.form.uuid;
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.visible = false;
                            this.$message.success("编辑成功");
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.visible = false;
                            this.$message.success("新增成功");
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
